import * as actions from './actions';

export const closeSupportDropdown = () => dispatch => {
  dispatch(actions.setMobileSupportMenuState(false));
  dispatch(actions.setSupportMenuState(false));
};

export const toggleMobileSupportMenuDropdownState = isOpen => dispatch => {
  dispatch(actions.setMobileSupportMenuState(isOpen));
};


export default {
  closeSupportDropdown,
  toggleMobileSupportMenuDropdownState
};
